/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const EllipsisVerticalIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M12 21.4a2.05 2.05 0 1 1 0-4.1 2.05 2.05 0 0 1 0 4.1m0-7.35a2.05 2.05 0 1 1 0-4.1 2.05 2.05 0 0 1 0 4.1m0-7.35a2.05 2.05 0 1 1 0-4.1 2.05 2.05 0 0 1 0 4.1" clipRule="evenodd" /></svg>;
};
export default EllipsisVerticalIcon;